import { EndorsementsEffects } from './endorsements.effects';

export const EndorsementsFeatureEffects = [EndorsementsEffects];
